if (!customElements.get('comparison-slider')) {
  class ComparisonSlider extends HTMLElement {
    connectedCallback() {
      this.afterEl = this.querySelector('[data-cs-after]');
      this.handle = this.querySelector('[data-cs-handle]');
      if (!this.afterEl || !this.handle) return;

      var initial = parseFloat(this.dataset.initialPosition) || 50;
      this.updatePosition(initial);

      this.isDragging = false;
      this.onDrag = this.onDrag.bind(this);
      this.stopDrag = this.stopDrag.bind(this);
      this.startDrag = this.startDrag.bind(this);
      this.handleKeyboard = this.handleKeyboard.bind(this);

      this.addEventListener('mousedown', this.startDrag);
      this.addEventListener('touchstart', this.startDrag, { passive: true });
      this.handle.addEventListener('keydown', this.handleKeyboard);

      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('touchmove', this.onDrag, { passive: true });
      document.addEventListener('mouseup', this.stopDrag);
      document.addEventListener('touchend', this.stopDrag);
    }

    disconnectedCallback() {
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('touchmove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
      document.removeEventListener('touchend', this.stopDrag);

      this.removeEventListener('mousedown', this.startDrag);
      this.removeEventListener('touchstart', this.startDrag);

      if (this.handle) {
        this.handle.removeEventListener('keydown', this.handleKeyboard);
      }
    }

    startDrag(event) {
      this.isDragging = true;
      var clientX = event.type.indexOf('touch') === 0 ? event.touches[0].clientX : event.clientX;
      this.updateFromClientX(clientX);
    }

    stopDrag() {
      this.isDragging = false;
    }

    onDrag(event) {
      if (!this.isDragging) return;
      var clientX = event.type.indexOf('touch') === 0 ? event.touches[0].clientX : event.clientX;
      this.updateFromClientX(clientX);
    }

    handleKeyboard(event) {
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
      event.preventDefault();
      var current = parseFloat(this.handle.style.left) || 50;
      if (event.key === 'ArrowLeft') current = Math.max(0, current - 5);
      if (event.key === 'ArrowRight') current = Math.min(100, current + 5);
      if (event.key === 'Home') current = 0;
      if (event.key === 'End') current = 100;
      this.updatePosition(current);
    }

    updateFromClientX(clientX) {
      var rect = this.getBoundingClientRect();
      var x = clientX - rect.left;
      var percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
      this.updatePosition(percentage);
    }

    updatePosition(percentage) {
      this.afterEl.style.clipPath = 'inset(0 0 0 ' + percentage + '%)';
      this.handle.style.left = percentage + '%';
      this.handle.setAttribute('aria-valuenow', Math.round(percentage));
    }
  }

  customElements.define('comparison-slider', ComparisonSlider);
}
